import { Component, NgModule, OnInit } from '@angular/core';
declare var $: any;

// Services
import {
  UserService, ResourceService, AuthService,
} from "@services/index.service";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

import { environment } from "@environments/environment";

// App Constants
import { AppConstants } from '@app/appConstants';

@Component({
  selector: 'app-mydocuments',
  templateUrl: './mydocuments.page.html',
  animations: environment.ANIMATIONS
})
export class MydocumentsComponent implements OnInit {

  isChrome: boolean;
  uploadDocument;

  constructor(public _userService: UserService,
    public _resourceService: ResourceService, public _authService: AuthService) {



    this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    if (_userService.user) {
      delete this._userService.user.documents
      this._userService.getPatientDocuments().subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
          let response = data as ResponseDataBase;
          this._userService.user.documents = response.result;
          this._resourceService.loading = false;
        } else {
          // this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
          this._resourceService.loading = false;
        }
      });
    }
  }

  ngOnInit() {
  }

  getDocument(patientDocument) {
    this._userService.getPatientDocument(patientDocument).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        let pdf = response.result;
        const linkSource = pdf[0].data;
        const downloadLink = document.createElement("a");
        const fileName = patientDocument.examResultTitle + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this._resourceService.loading = false;
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._resourceService.loading = false;
      }
    });
  }

  viewDocument(patientDocument) {
    this._userService.getPatientDocument(patientDocument).subscribe(data => {
      let response = data as ResponseDataBase;
      let pdfWindow = window.open("");
      let pdf = response.result[0].data;
      pdfWindow.document.write("<iframe width='100%' height='100%' src='" + pdf + "'></iframe>");
      this._resourceService.loading = false;
    });
  }

  putNameInField() {
    if (this.uploadDocument) {
      var filename = this.uploadDocument.replace(/^.*[\\\/]/, '')
      document.getElementById("fileLabel").innerHTML = filename;
    }
  }

  uploadFile() {
    console.log('Uploading Document...', this.uploadDocument);
  }

}
